"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f331 = void 0;
exports.f331 = {
    "ŋgɨgɨ ɨrkŋɨ": [
        141
    ],
    "ŋgɨgɨ": [
        141
    ],
    "ŋgɔmba": [
        3359
    ],
    "ŋakaramojoŋ": [
        3541
    ],
    "ŋakarimojoŋ": [
        3541
    ],
    "ŋmampulli": [
        4596,
        4597
    ],
    "ŋmampəlli": [
        4596,
        4597
    ],
    "ŋga": [
        4797
    ],
    "ŋatoposa": [
        7651
    ]
};
